<script lang="ts">
  import { faHome } from "@fortawesome/free-solid-svg-icons";
  import Fa from "svelte-fa";
  import { navigate } from "svelte-routing";

  import { Button, Col, Modal, ModalBody, Row } from "sveltestrap";
  import { gamestate } from "../stores";
  import Headline from "./Headline.svelte";
  import StarRating from "./StarRating.svelte";

  export let isOpen: boolean;

  let headlinesSorted = [];
  $: headlinesSorted = $gamestate.activeHeadlines.sort(
    (a, b) => (b.views.latest || 0) - (a.views.latest || 0)
  );
</script>

<Modal size="xl" {isOpen}>
  <h2 class="modal-header d-flex bg-black text-light">
    Game Summary
    <span class="flex-grow-1" />

    <Button class="sans" color="light" on:click={() => navigate("/")}>
      <Fa icon={faHome} /> Main Menu
    </Button>
  </h2>

  <ModalBody>
    <Row>
      <Col>
        <h3 class="sans">Profit</h3>
        <span class="display-4">${$gamestate.money.latest.toFixed(2)}</span>
      </Col>

      <Col>
        <h3 class="sans mt-3">Subscribers</h3>
        <span class="display-4">{$gamestate.subscribers.length}</span>
      </Col>

      <Col>
        <h3 class="sans mt-3">Rating</h3>
        <span class="display-6 mt-3">
          <StarRating stars={$gamestate.rating} />
        </span>
      </Col>
    </Row>

    <h3 class="sans">All Headlines</h3>
    {#each headlinesSorted as headline}
      <Headline {headline} />
    {/each}
  </ModalBody>
</Modal>
